module.exports = __webpack_public_path__ + "img/rovaniemi-1944.93e0d1ce.jpg";